import { provideChameleonDesignSystem } from '../../provideChameleonDesignSystem';
import { chameleonDataTableRowV2 } from './definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonDataTableRowV2({ prefix }));
}
